module.exports = __webpack_public_path__ + "static/media/i86a.1b4a2ba8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/i86a.svg
// module id = 406
// module chunks = 12